import React from 'react';
import { Box } from '@mui/material';

export const MAIN_CONTENT_ID = 'conteudo';
export const MAIN_MENU_ID = 'menu-principal';

const focusTarget = (id: string) => (event: React.MouseEvent<HTMLAnchorElement>) => {
  const target = document.getElementById(id);
  if (!target) return;
  event.preventDefault();
  // O alvo precisa ser focável para leitores de tela anunciarem o novo ponto da página
  if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
  target.focus();
  target.scrollIntoView({ block: 'start' });
};

/**
 * Atalhos de teclado (padrão e-MAG): primeiros elementos focáveis da página,
 * visíveis apenas ao receber foco.
 */
export default function SkipLinks() {
  const links = [
    { id: MAIN_CONTENT_ID, label: 'Pular para o conteúdo' },
    { id: MAIN_MENU_ID, label: 'Ir para o menu' },
  ];

  return (
    <Box component="nav" aria-label="Atalhos de acessibilidade">
      {links.map((link) => (
        <Box
          key={link.id}
          component="a"
          href={`#${link.id}`}
          onClick={focusTarget(link.id)}
          sx={{
            position: 'absolute',
            left: 16,
            top: 8,
            zIndex: (theme) => theme.zIndex.tooltip + 1,
            px: 2,
            py: 1.5,
            borderRadius: 1,
            backgroundColor: 'background.paper',
            color: 'brand.text',
            fontWeight: 600,
            boxShadow: 4,
            transform: 'translateY(-200%)',
            '&:focus': {
              transform: 'translateY(0)',
            },
          }}
        >
          {link.label}
        </Box>
      ))}
    </Box>
  );
}
